import { useState, useEffect } from "react";
import CredentialForm from "./CredentialForm";
import CredentialInformation from "./CredentialInformation";
import CredentialNotFound from "./CredentialNotFound";
import { StyledBox } from "../../components/StyledBox";

const credentialType = "NCRC";
const credentialPattern = /^(?:[A-Za-z0-9]{12}|[A-Za-z0-9]{14})$/;

const CredentialMain: React.FC = () => {
    const [credentialId, setCredentialId] = useState("");
    const [isCredentialIdValid, setIsCredentialIdValid] = useState(false);
    const [data, setData] = useState({});
    const [error, setError] = useState(false);
    const [domain, setDomain] = useState("");
    const [isLegacy, setIsLegacy] = useState(false);

    useEffect(() => {
      if(window?.location?.hostname.includes("dev") || window?.location?.hostname.includes("localhost")){
        setDomain("-dev");
      }else if(window?.location?.hostname.includes("tst")){
        setDomain("-test");
      }else if(window?.location?.hostname.includes("str")){
        setDomain("-stress");
      }else{
        setDomain("");
      }
    },[])

    const formatDate = (dateString: string) => {
      const date = new Date(dateString);
      const formattedDate = date.toLocaleDateString("en-US",{
        month: "2-digit",
        day: "2-digit",
        year: "numeric"
      })
      return formattedDate;
    }

    const getCredentials=()=>{
      const baseUrl = `https://api2${domain}.act.org/cresvc_1.0.0/certificates/${credentialId}`;

      fetch(`${baseUrl}`)
        .then(function(response){
          if(!response.ok){
            throw new Error("Please try again...");
          }
          return response.json();
        })
        .then(function(data) {
          setError(false);
          const apiData = {
            credentialId: data?.certificate_identifier,
            credentialType: `${data?.certificate_type_name}`,
            issueDate: formatDate(data?.created_at),
            firstName: data?.first_name,
            lastName: data?.last_name,
            middleName: data?.middle_name,
            description: `${data?.certificate_level_description}`
          };
          setData(apiData);
        })
        .catch(function(error){
          setData({});
          setError(true);
        });
    }

    const getLegacyCredentials = () => {
      const baseUrl = `https://api2${domain}.act.org/cresvc_1.0.0/certificates/legacy/${credentialId}`;

      fetch(`${baseUrl}`)
        .then(function(response){
          if(!response.ok){
            throw new Error("Please try again...");
          }
          return response.json();
        })
        .then(function(data) {
            setError(false);
            const apiData = {
              credentialId: data?.certificate_identifier,
              credentialType: data?.certificate_type_name,
              issueDate: "",
              firstName: data?.first_name,
              lastName: data?.last_name,
              middleName: "",
              description: data?.certificate_level_description
            };
            setData(apiData);
        })
        .catch(function(error){
          setData({});
          setError(true);
        });
    }

    const handleChange = (id: string) => {
        setCredentialId(id);
        setIsCredentialIdValid(credentialPattern.test(id));
    }

    const handleSubmit = () => {
      setData({});
      if(credentialId.length === 14){
          setIsLegacy(false);
          getCredentials();
        }else{
          setIsLegacy(true);
          getLegacyCredentials();
        }
    }

    const handleReset = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setError(false);
        setData({});
        setCredentialId("");
        setIsLegacy(false);
    }

    return(
        <StyledBox>
            {!error && <CredentialForm credentialId={credentialId} credentialType={credentialType} isCredentialIdValid={isCredentialIdValid} handleChange={handleChange} handleSubmit={handleSubmit}/>}
            {!error && Object.keys(data).length > 0 && <CredentialInformation credentials={data} isLegacy={isLegacy} />}
            {error && <CredentialNotFound credentialId={credentialId} handleReset={handleReset} />}
        </StyledBox>
    );
}

export default CredentialMain;
